/* eslint-disable */
import store from '@/store/index'
import Vue from 'vue'

import WidgetServices from '@/services/Widget'

class Storage {
  STORAGE_NAME: any = 'ocular-app'
  storage: any = {}
  states: any = [
    {
      id: 1,
      name: 'progress',
      actionState: false
    },
    {
      id: 2,
      name: 'calling',
      actionState: true
    },
    {
      id: 3,
      name: 'queue',
      actionState: true
    },
    {
      id: 4,
      name: 'call',
      actionState: true
    },
    {
      id: 5,
      name: 'rating',
      actionState: true
    },
    {
      id: 6,
      name: 'Finished',
      actionState: false
    },
    {
      id: 7,
      name: 'Optimizando',
      actionState: true
    }
  ]

  updateStorageData () {
    if (store.state.widget.isBusy) {
      return false
    }

    window.parent.postMessage(`ocularStorage.updateStorageData(${JSON.stringify(store.state.storage)})`, '*')
    this.storage = store.state.storage
  }

  finishStorage (hard:boolean = false) {
    if (hard) {
      store.state.lobbySession = null
      store.state.linkSession = null
    } else if (store.state.lobbySession) {
      this.setStorageRoom(store.state.lobbySession)
      this.setState(4)
      store.state.lobbySession = null
    } else if (store.state.linkSession) {
      if (store.state.linkSession.status === 'progress') {
        const data = {
          id: store.state.linkSession.id,
          customer: store.state.linkSession.customer,
          config: {
            camera: true,
            microphone: true,
            screen: false
          }
        }
        this.setStorageRoom(data)
        this.setState(4)
      } else {
        this.setState(2)
      }
    }

    store.state.services.storage.completed = true
  }

  initializeStorageData (hard:boolean = false) {
    store.state.storage = {
      activeRoute: !hard && this.storage && this.storage.activeRoute ? this.storage.activeRoute : '/',
      state: !hard && this.storage && this.storage.state ? this.storage.state : this.states[0],
      category: !hard && this.storage && this.storage.category ? this.storage.category : null,
      codec: !hard && this.storage && this.storage.codec ? this.storage.codec : 'VP8',
      form: {
        code: !hard && this.storage && this.storage.form && this.storage.form.code ? this.storage.form.code : null
      },
      widget: {
        code: this.storage && this.storage.widget ? this.storage.widget.code : null
        // code: !hard && this.storage && this.storage.widget ? this.storage.widget.code : null
      },
      device: {
        camera: !hard && this.storage && this.storage.device ? this.storage.device.camera : true,
        microphone: !hard && this.storage && this.storage.device ? this.storage.device.microphone : true,
        screen: !hard && this.storage && this.storage.device ? this.storage.device.screen : false
      },
      room: {
        currentLocation: this.storage && this.storage.room && this.storage.room.currentLocation ? this.storage.room.currentLocation : { url: null, title: null },
        connected: this.storage && this.storage.room && this.storage.room && typeof this.storage.room.connected !== 'undefined' ? this.storage.room.connected : false,
        customer: this.storage && this.storage.room && this.storage.room.customer ? this.storage.room.customer : null,
        cammer: !hard && this.storage && this.storage.room && this.storage.room.cammer ? this.storage.room.cammer : { user: {} },
        publisher: !hard && this.storage && this.storage.room && this.storage.room.publisher ? this.storage.room.publisher : null,
        publisherSettings: !hard && this.storage && this.storage.room && this.storage.room.publisherSettings ? this.storage.room.publisherSettings : null,
        chat: !hard && this.storage && this.storage.room && this.storage.room.chat ? this.storage.room.chat : [],
        recommendations: !hard && this.storage && this.storage.room && this.storage.room.recommendations ? this.storage.room.recommendations : [],
        session: {
          id: !hard && this.storage && this.storage.room && this.storage.room.session.id ? this.storage.room.session.id : null,
          tokboxId: !hard && this.storage && this.storage.room && this.storage.room.session.tokboxId ? this.storage.room.session.tokboxId : null,
          token: !hard && this.storage && this.storage.room && this.storage.room.session.token ? this.storage.room.session.token : null
        },
        streams: []
      }
    }

    this.updateStorageData()

    this.finishStorage(hard)
  }

  setState (id: Number) {
    const state = this.states.find((state: any) => state.id === id)
    this.storage = store.state.storage
    this.storage.state = state
    store.state.storage = this.storage
    this.updateStorageData()
  }

  setLocale (lang: any) {
    this.storage = store.state.storage
    this.storage.widget.lang = lang
    store.state.storage = this.storage

    WidgetServices.setLocale(lang)
  }

  setCustomer (customer: any) {
    this.storage = store.state.storage
    this.storage.room.customer = customer
    store.state.storage = this.storage
    this.updateStorageData()
  }

  setCodec (codec: any) {
    this.storage = store.state.storage
    this.storage.codec = codec
    store.state.storage = this.storage
    this.updateStorageData()
  }

  setRecommendedPublisher (publisherSettings: any) {
    this.storage = store.state.storage
    this.storage.room.publisherSettings = publisherSettings
    store.state.storage = this.storage
    this.updateStorageData()
  }

  setStorageRoom (session: any) {
    this.storage = store.state.storage

    if (!this.storage.room) {
      return false
    }

    this.storage.room.session.id = session && session.id ? Number(session.id) : null
    this.storage.room.session.tokboxId = session && session.session_id ? session.session_id : null
    this.storage.room.session.token = session && session.token ? session.token : null

    if (session && session.config) {
      this.storage.device.camera = session.config.camera
      this.storage.device.microphone = session.config.microphone
      this.storage.device.screen = session.config.screen
    }

    this.updateStorageData()

    if (session && session.customer) {
      if (session.customer.cellphone) {
        const countries = require('@/resources/json/countries.json')
        for (let index = 0; index < countries.length; index++) {
          const country = countries[index]
          const cellphone = session.customer.cellphone.split(country.dial_code)[1]
          if (cellphone) {
            session.customer.cellphone = cellphone
            session.customer.countryCode = country.dial_code
            break
          }
        }
      }

      this.setCustomer(session.customer)
    }
  }

  setCammer (cammer: any) {
    this.storage = store.state.storage
    this.storage.room.cammer.user = cammer.user
    store.state.storage = this.storage
    this.updateStorageData()
  }

  setRoomConnection (connected: any) {
    this.storage = store.state.storage
    this.storage.room.connected = connected
    store.state.storage = this.storage
    this.updateStorageData()
  }

  setRoomPublisher (publisher: any) {
    this.storage = store.state.storage
    this.storage.room.publisher = publisher ? { id: publisher.id } : null
    store.state.storage = this.storage
    this.updateStorageData()
  }
}

window.onfocus = () => {
  store.state.widget.onfocus = true
}

window.onblur = () => {
  store.state.widget.onfocus = false
}

Vue.prototype.$storage = new Storage()
const ocularStorage = <any> new Storage()

const receiver = (event: any) => {
  const message = event.data;

  if (!message || typeof message !== 'string' || message.includes('webpack')) {
    return false;
  }

  const expression = message.split('(');
  const keyFunctionName = expression[0];
  const dataString = message.slice(`${keyFunctionName}(`.length, -1);

  const func = keyFunctionName.split('.')[1];
  const params = JSON.parse(`[${dataString}]`);

  try {
    ocularStorage[func](...params);
  } catch (error) {
    // console.error(`Función ${keyFunctionName} no encontrada o no es una función válida.`);
  }
}

window.addEventListener('message', receiver, false);
